import Header from './components/Header';
import Hero from './components/Hero';
import CarouselSection from './components/CarouselSection';
import TopicsSection from './components/TopicsSection';
import ContactSection from './components/ContactSection';
import RankingSection from './components/RankingSection';
import UpdatesSection from './components/UpdatesSection';
import FeaturesSection from './components/FeaturesSection';
import CardsSection from './components/CardsSection';
import CommentsSection from './components/CommentsSection';
import MediaSection from './components/MediaSection';
import AppSection from './components/AppSection';
import IndexSection from './components/IndexSection';
import AboutSection from './components/AboutSection';
import FaqSection from './components/FaqSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <Hero />
        <CarouselSection />
        <TopicsSection />
        <ContactSection />
        <RankingSection />
        <UpdatesSection />
        <FeaturesSection />
        <CardsSection />
        <CommentsSection />
        <MediaSection />
        <AppSection />
        <IndexSection />
        <AboutSection />
        <FaqSection />
      </main>
      <Footer />
    </div>
  );
}